import PropTypes from 'prop-types';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const LateralCard = styled(List)(({ theme }) => ({
    color: '#fff',
    overflow: 'hidden',
    position: 'relative'
}))

const NavGroup = ({ item, drawerOpen, openMenu, handleMenuClick }) => {
    const theme = useTheme();

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse drawerOpen={drawerOpen} key={menu.id} menu={menu} level={1} openMenu={openMenu} handleMenuClick={handleMenuClick} />;
            case 'item':
                return <NavItem drawerOpen={drawerOpen} key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <LateralCard
                subheader={
                    item.title && (
                        <Typography variant="caption" style={{fontSize:"13px"}} sx={{ ...theme.typography.menuCaption, color: 'white' }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </LateralCard>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 0.5 }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object.isRequired,
    drawerOpen: PropTypes.bool.isRequired,
    openMenu: PropTypes.string, 
    handleMenuClick: PropTypes.func.isRequired,
};

export default NavGroup;
